(() => {
  const config = JSON.parse(document.getElementById('us-despatch-config').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const london = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'});
  function date() {
    const settings = window.USDeliveryManagerConfig;
    const now = new Date();
    if (!settings?.enabled || (settings.startsAt && now < new Date(settings.startsAt)) || (settings.endsAt && now >= new Date(settings.endsAt))) return null;
    const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const part = key => parts.find(p => p.type === key).value;
    const day = new Date(`${part('year')}-${part('month')}-${part('day')}T12:00:00Z`);
    const days = Number(settings.leadDays);
    if (!Number.isInteger(days) || days < 1 || days > 60) return null;
    let remaining = days;
    while (remaining > 0) {day.setUTCDate(day.getUTCDate()+1);if(!settings.workingDays || ![0,6].includes(day.getUTCDay()))remaining--;}
    while ([0,6].includes(day.getUTCDay())) day.setUTCDate(day.getUTCDate()+1);
    return {iso:day.toISOString().slice(0,10),text:new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',timeZone:'UTC'}).format(day)};
  }
  function isPreorder(existing = {}, sellingPlanName = '') {
    return /pre[\s_-]?order/i.test(sellingPlanName) || Object.entries(existing).some(([key, value]) => /pre[\s_-]?order/i.test(key) && value != null && String(value).trim() !== '');
  }
  function properties(existing = {}, sellingPlanName = '') {
    const next = {...existing};
    delete next.Ships;
    delete next['Despatch date'];
    delete next._us_despatch_date;
    const current = date();
    if (current && !isPreorder(existing, sellingPlanName)) {
      next['Despatch date'] = current.text;
      next._us_despatch_date = current.iso;
    }
    return next;
  }
  const variantData = new WeakMap();
  const selectedVariants = new WeakMap();
  function productState(form) {
    const source = form?.querySelector('[data-us-despatch-variants]');
    if (!source) return null;
    if (!variantData.has(source)) {
      try { variantData.set(source, JSON.parse(source.textContent)); }
      catch { return null; }
    }
    const data = variantData.get(source);
    const selected = selectedVariants.get(form) || form.elements.namedItem('id')?.value || data.selected;
    const variant = data.variants.find(item => String(item.id) === String(selected));
    if (!variant) return null;
    let preorder = Boolean(variant.managed && variant.policy === 'continue' && variant.quantity <= 0);
    const embed = document.querySelector('essential-preorder-app-embed');
    if (embed) {
      try {
        const campaigns = JSON.parse(embed.getAttribute('preorder-app-data') || '{}').preorderCampaigns || [];
        const market = window.essentialPreorderConfigs?.selectedMarketId || '';
        const matches = campaign => (campaign.placement?.specificProducts || []).some(id => String(id).split('/').pop() === String(variant.id)) || campaign.sellingPlanIds?.some(id => variant.plans.some(plan => String(plan) === String(id)));
        const campaign = campaigns.find(item => matches(item) && item.content.marketType === 'SPECIFIC' && item.content.specificMarkets?.some(item => item.shopifyId.split('/').pop() === String(market))) || campaigns.find(item => matches(item) && (!item.content.marketType || item.content.marketType === 'ALL'));
        if (campaign) preorder = campaign.content.preorderType === 'IN_STOCK' ? variant.quantity > 0 : campaign.content.preorderType === 'OUT_OF_STOCK' ? variant.quantity <= 0 : true;
      } catch {}
    }
    return {available: variant.available, preorder};
  }
  function formPreorder(form) {
    if (!form) return false;
    const state = productState(form);
    if (state) return state.preorder;
    return isPreorder(Object.fromEntries(Array.from(form.querySelectorAll('[name^="properties["]')).map(input => [input.name, input.value])));
  }
  window.usDespatch = {date, properties, isPreorder, productState};
  let syncedDate = '';
  function refresh() {
    const current = date();
    const syncKey = (current?.iso || 'normal') + ':' + (window.USDeliveryManagerConfig?.revision || 0);
    if (window.USDeliveryManagerConfig && syncedDate !== syncKey) {
      syncedDate = syncKey;
      syncCart().catch(() => { syncedDate = ''; });
    }
    document.querySelectorAll('[data-us-despatch-date]').forEach(element => {
      const formId = element.dataset.usDespatchForm;
      const form = formId ? document.getElementById(formId) : null;
      const state = productState(form);
      element.hidden = !current || Boolean(formId && (!state || !state.available || state.preorder));
      if (current) {
        const text = element.hasAttribute('data-us-despatch-value') ? current.text : 'Ships ' + current.text;
        if (element.textContent !== text) element.textContent = text;
      }
    });
    document.querySelectorAll('[data-us-despatch-inputs]').forEach(wrapper => {
      const preorder = formPreorder(wrapper.closest('form'));
      const state = productState(wrapper.closest('form'));
      wrapper.querySelectorAll('input').forEach(input => {
        input.disabled = !current || preorder || Boolean(state && !state.available);
        if (current) input.value = input.name === 'properties[Despatch date]' ? current.text : current.iso;
      });
    });
    const dialog = document.getElementById('us-despatch-notice');
    const settings = window.USDeliveryManagerConfig;
    if (!dialog) return;
    if (!current || !settings?.popup) {if(dialog.open)dialog.close();return;}
    document.getElementById('us-despatch-title').textContent = settings.title;
    const message = document.getElementById('us-despatch-message');
    const renderedKey = settings.message + ':' + current.iso;
    if(message.dataset.rendered !== renderedKey) {
      message.replaceChildren();
      settings.message.split('{date}').forEach((part,index)=>{if(index){const strong=document.createElement('strong');strong.textContent=current.text;message.append(strong);}message.append(document.createTextNode(part));});
      message.dataset.rendered = renderedKey;
    }
    if (dialog.open) return;
    const key = 'us-despatch-seen-' + current.iso + ':' + settings.revision;
    let seen = dialog.dataset.seen === current.iso;
    try { seen ||= sessionStorage.getItem(key) === '1'; } catch {}
    if (!seen) {
      dialog.dataset.seen = current.iso;
      try { sessionStorage.setItem(key, '1'); } catch {}
      dialog.showModal();
    }
  }
  let syncing;
  async function syncCart() {
    if (syncing) return syncing;
    if (!window.USDeliveryManagerConfig) return;
    syncing = (async () => {
      const response = await fetch(root + 'cart.js', {cache: 'no-store'});
      if (!response.ok) throw Error(config.error);
      let cart = await response.json();
      for (let attempt = 0; attempt < 100; attempt++) {
        const item = cart.items.find(line => {
          if (!line.requires_shipping) return false;
          const previous = line.properties || {};
          const next = properties(previous, line.selling_plan_allocation?.selling_plan?.name);
          return previous.Ships !== undefined || previous['Despatch date'] !== next['Despatch date'] || previous._us_despatch_date !== next._us_despatch_date;
        });
        if (!item) return;
        const next = properties(item.properties || {}, item.selling_plan_allocation?.selling_plan?.name);
        const changed = await fetch(root + 'cart/change.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: item.key, quantity: item.quantity, properties: next})
        });
        if (!changed.ok) throw Error(config.error);
        cart = await changed.json();
      }
      throw Error(config.error);
    })().finally(() => { syncing = null; });
    return syncing;
  }
  function showError(form) {
    let error = form.querySelector('[data-us-despatch-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.usDespatchError = '';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = config.error;
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('[data-us-despatch-inputs]')) refresh();
    const action = new URL(form.action, location.href);
    const isCart = /\/cart\/?$/.test(action.pathname);
    if (!isCart || event.submitter?.name !== 'checkout' || form.dataset.usDespatchReady) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await syncCart();
      form.dataset.usDespatchReady = '1';
      form.requestSubmit(event.submitter);
      delete form.dataset.usDespatchReady;
    } catch { showError(form); }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || !/\/checkout\/?$/.test(new URL(link.href, location.href).pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try { await syncCart(); location.assign(link.href); }
    catch { showError(link.closest('form') || link.parentElement); }
  }, true);
  document.addEventListener('cart:change', () => {
    refresh();
    syncCart().catch(() => {});
  });
  document.addEventListener('us-delivery:ready', refresh);
  document.addEventListener('change', event => {if(event.target.closest?.('form[action*="/cart/add"]'))refresh();}, true);
  document.addEventListener('pointerdown', event => {if(event.target.closest?.('buy-buttons, .shopify-payment-button'))refresh();}, true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('variant:change', event => {
    const form = event?.target?.closest?.('form');
    if (form && event.detail?.variant?.id) selectedVariants.set(form, event.detail.variant.id);
    refresh();
  }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => record.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }).observe(document.body, {childList: true, subtree: true});
  refresh();
  setInterval(refresh, 15000);
})();



